import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {useAuth} from "@/context/use-auth.tsx";
import {UserBaseDTO, UserDTO} from "@/models/user.ts";
import {editUser, getUserData} from "@/services/user-services.ts";
import UserForm from "@/components/user-form.tsx";
import {useUsersTranslation} from "@/i18n/hooks";
import log from '@/lib/logger'

export default function EditUserPage() {
    const navigate = useNavigate()
    const {userId} = useParams()
    const [userData, setUserData] = useState<UserDTO | null>(null)
    const [isLoading, setIsLoading] = useState(true)
    const [loadError, setLoadError] = useState<string | null>(null)
    const {token} = useAuth()
    const {t} = useUsersTranslation()

    useEffect(() => {
        if (!userId || !token) {
            setLoadError(t("editPage.errors.missingIdOrToken"))
            setIsLoading(false)
            return
        }

        setIsLoading(true)
        setLoadError(null)

        const userFromServer = getUserData(userId, token)
        userFromServer
            .then((userData) => {
                setUserData(userData as UserDTO)
                setIsLoading(false)
            })
            .catch((error) => {
                log.error("Error retrieving user data:", error)
                setLoadError(t("editPage.errors.loadingFailed"))
                setIsLoading(false)
            })
    }, [userId, token]);

    const onSubmit = async (formData: any) => {
        const userUpdateData: UserBaseDTO = {
            active: formData.active,
            id: formData.id,
            name: formData.name,
            role: formData.role,
            email: formData.email || undefined,
        }

        // Let the rejection propagate so UserForm can surface backend validation issues as field
        // errors instead of swallowing them here.
        await editUser(userUpdateData, token!)
        navigate("/admin/users")
    }

    return (
        <UserForm 
            mode="edit"
            initialData={userData || undefined}
            onSubmit={onSubmit}
            isLoading={isLoading}
            loadError={loadError}
            userId={userId}
        />
    )
}